import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';

import style from "./LoginForm.module.css";
import googleIcon from "../../assets/google-icon-light.svg"

const LoginForm = ({ mode, formData, handleChange, handleSubmit, loading, googleLogin, setMode, promoOpen }) => {
  const { t } = useTranslation();
  const [showPromo, setShowPromo] = useState(promoOpen || false);

  return (
    <form 
        onSubmit={handleSubmit} 
        className={style.form}
    >
      {mode === "signup" && (
        <TextField
          type="text"
          name="full_name"
          placeholder={t('common.name')}
          value={formData.full_name}
          onChange={handleChange}
          required
          id="outlined-required"
          label={t('common.name')}
          fullWidth
          margin="normal"
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
        />
      )}
      <TextField 
        type="email" 
        name="email" 
        placeholder="Email" 
        value={formData.email} 
        onChange={handleChange} 
        required 
        id="outlined-required"
        label="Email"
        fullWidth
        margin="normal"
        slotProps={{
            inputLabel: {
              shrink: true,
            },
        }}
      />
      <TextField 
        type="password" 
        name="password" 
        placeholder={t('common.password')}
        value={formData.password}
        onChange={handleChange}
        required
        autoComplete="current-password"
        label={t('common.password')}
        fullWidth
        margin="normal"
        slotProps={{
            inputLabel: {
              shrink: true,
            },
        }}
      />

      {mode === "signin" && (
        <p className={style.forgotPassword}>
          <Link to="/forgot-password">{t('auth.forgot_password')}</Link>
        </p>
      )}

      {mode === "signup" && (
        <>
          {!showPromo && (
            <p className={style.promoToggle} onClick={() => setShowPromo(true)}>
              {t('auth.has_promo')}
            </p>
          )}
          {showPromo && (
            <TextField
              type="text"
              name="promo_code"
              placeholder={t('auth.promo_code')}
              value={formData.promo_code}
              onChange={handleChange}
              label={t('auth.promo_code')}
              fullWidth
              margin="normal"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
            />
          )}
        </>
      )}
      <div className={style.buttonsContainer}>  
        <button type="submit" className={`button ${style.loginButton}`} disabled={loading}>
            {loading ? t('common.loading') : mode === "signin" ? t('auth.login_btn') : t('auth.register_btn')}
        </button>
        {/*
        <button type="button" className={`button ${style.googleButton}`} onClick={googleLogin}>
            <img src={googleIcon} alt=""/>
            Увійти через Google
        </button>
        */}
      </div>
      

      <p className={`grey-text ${style.switchText}`}>
        {mode === "signin" ? t('auth.no_account') : t('auth.has_account')}{" "}
        <span onClick={() => setMode(mode === "signin" ? "signup" : "signin")}>
          {mode === "signin" ? t('auth.register_btn') : t('auth.login_btn')}
        </span>
      </p>
    </form>
  );
};
export default LoginForm;
